const properties = {
    BUILD_TYPE: "production", //production or development
    DOMAIN_URL: "amigogroup.net"
};

export default properties;
